import React from 'react';
import Form, { Actions, RequiredValidator, TextField } from '../../../Components/Form';

const MfaChallenge = ({ onSubmit }) => {
    return <Form onSubmit={onSubmit}>
        <TextField
            type="text"
            name="code"
            label="Verification code"
            placeholder="000000"
            maxLength={6}
            validators={[RequiredValidator]}
            autoComplete="one-time-code"
        />
        <Actions submit={{label: 'Verify'}} />
    </Form>;
};

export default MfaChallenge;
